<template>
  <section>
    <div class="accordion accordion-flush" id="accordion-feature">
      <div v-for="(category, idx) in categories" :key="idx" class="accordion-item">
        <div class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            :data-bs-target="`#accordion-feature-${idx}`" :aria-controls="`accordion-feature-${idx}`"
            aria-expanded="false">
            <span class="custom-category">{{ category }}</span>
          </button>
        </div>
        <div :id="`accordion-feature-${idx}`" class="accordion-collapse collapse" data-bs-parent="#accordion-feature">
          <div class="accordion-body">
            <ul class="custom-list">
              <li v-for="item in categoryItems(category)" :key="item.vehicleAdas">
                <span class="custom-item">{{ item }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'pinia'
import { buildStore } from '@/stores/build'
import globals from '@/plugins/globals'
export default {
  name: 'installed-equipment',
  computed: {
    ...mapState(buildStore, ['build']),
    categories() {
      const src = this.build?.installed_equipment;
      if (!src) return [];

      // Flatten to items
      const items =
        Array.isArray(src?.STANDARD) ? src.STANDARD :
          Array.isArray(src) ? src :
            Object.values(src).flat();

      if (!items?.length) return [];

      const sorted = globals.sortArray2(items, 'category', 'ASC');
      const norm = s => s == null ? '' : String(s).trim().toLowerCase();

      // Unique by normalized key, but present nicely
      const seen = new Set();
      const out = [];
      for (const it of sorted) {
        const key = norm(it.category);
        if (!key) continue;                // skip null/blank categories
        if (!seen.has(key)) {
          seen.add(key);
          // Title-case for display (optional)
          out.push(key.replace(/\b\w/g, c => c.toUpperCase()));
        }
      }
      return out;
    },
    // categories() {
    //   let _data = []
    //   if (this.build) {
    //     if (this.build.installed_equipment) {
    //       let last = ''
    //       let sortedArray = null
    //       if (this.build.installed_equipment["STANDARD"]) {
    //         sortedArray = globals.sortArray(this.build.installed_equipment["STANDARD"], 'category')
    //       } else {
    //         sortedArray = globals.sortArray(this.build.installed_equipment, 'category')
    //       }
    //       if (sortedArray) {
    //         sortedArray.forEach(element => {
    //           if (last !== element.category) {
    //             _data.push(element.category)
    //           }
    //           last = element.category
    //         })
    //       }
    //     }
    //   }
    //   return _data
    // }
  },
  methods: {
    categoryItems(category) {
      let data = []
      let found = null
      if (this.build.installed_equipment) {
        if (this.build.installed_equipment["STANDARD"]) {
          found = this.build.installed_equipment["STANDARD"].filter(x => x.category === category)
        } else {
          found = this.build.installed_equipment.filter(x => x.category === category)
        }
      }
      if (found) {
        found = globals.sortArray2(found, 'item')
        found.forEach(element => {
          let description = `${element.category}: ${element.item}`
          if (element.location.trim() !== '') {
            description += ` (${element.location})`
          }
          if (element.item != element.attribute) {
            description += ` - ${element.attribute}: ${element.value}`
          }
          data.push(description)
        })
      }
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-accordion-tab {
  font-size: 1.1em;
  font-weight: 600;
}

.custom-list {
  list-style-type: none;

  li {
    padding: 5px;
  }

  li:hover {
    background-color: rgb(219, 219, 219);
    cursor: pointer;
  }
}

.custom-item {
  width: 100%;
}

.custom-category {
  font-weight: 500;
  font-size: 1.0em;
  font-style: italic;
}
</style>
